import { Sparkles, Zap, Eye, Cloud } from 'lucide-react';
import PillButton from './PillButton';

interface MoodChipProps {
  mood: 'Moved' | 'Empowered' | 'Curious' | 'Heavy';
  selected?: boolean;
  onClick?: () => void;
  cardId?: string;
}

const moodConfig = {
  Moved: {
    icon: Sparkles,
  },
  Empowered: {
    icon: Zap,
  },
  Curious: {
    icon: Eye,
  },
  Heavy: {
    icon: Cloud,
  },
};

export default function MoodChip({ mood, selected = false, onClick, cardId }: MoodChipProps) {
  const config = moodConfig[mood];
  const Icon = config.icon;

  const handleClick = () => {
    // Event tracking handled by parent component via onClick
    onClick?.();
  };

  const icon = <Icon className="w-4 h-4" strokeWidth={2} />;

  return (
    <PillButton
      onClick={handleClick}
      icon={icon}
      selected={selected}
      className="px-6"
    >
      {mood}
    </PillButton>
  );
}
